import ReportView from 'src/sections/overview/report/view/report-view';

export default function Report() {
  return <ReportView />;
}
